import React from 'react'
import LoadingSpinner from './LoadingSpinner'
import styled from 'styled-components'

const LoadingContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
`

interface CenteredLoaderProps {
    chainId: string
    brand: string
}

const CenteredLoader = ({chainId, brand}: CenteredLoaderProps) => (
    <LoadingContainer>
		<LoadingSpinner chainId={chainId} brand={brand} />
	</LoadingContainer>
)

export default CenteredLoader   
